// extracted by mini-css-extract-plugin
export default {"FAQ":"FAQ_FAQ__rhPbq","Question":"FAQ_Question__Aw2PB","Answer":"FAQ_Answer__DiiN8"};